import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

const duration = 0.5 // in seconds

const loadingScreen = document.querySelector('.loading-screen');
const html = document.documentElement
const tl = gsap.timeline({
	defaults: {
		ease: "power2.inOut"
	}
});

export default {
	name: 'fade',
	sync: false,
	before() {
		loadingScreen.classList.add('is-active');
	},
	leave(data) {
		return tl
			.to(loadingScreen, {
				height: '100%',
				duration: duration,
			})
			.to(data.next.container, {
				opacity: 1,
				duration: 0
			});
	},
	afterEnter() {
		return tl.set(loadingScreen, {
			css: { 
				top: 'auto',
				bottom: 0
			}
		});
	},
	after(data) {
		loadingScreen.classList.remove('is-active');
		html.classList.remove('is-loading')
		return tl
			.to(window, {
				scrollTo: 0,
				duration: 0.2
			})
			.from(data.next.container, {
				opacity: 0,
				duration: 0
			})
			.to(loadingScreen, {
				height: '0%',
				duration: duration,
			})
			.set(loadingScreen, {
				css: {
					top: 0,
					bottom: 'auto'
				}
			});
	}
}
